import React from 'react';
import _ from 'lodash';
import { Box, Typography } from "@mui/material";
import useAppInfo from '../../../../hooks/appInfo.hook';
import { useUser } from "../../../../contexts/user.context";
import Warnings from "../../../../components/publish/Warnings";
import MissingDataCard from "../../../../components/publish/MissingDataCard";
import PublishedCard from "../../../../components/publish/PublishedCard";
import PublishButton from "../../../../components/publish/PublishButton";
import AppStatus from '../../Main/AppStatus';
import AppleIcon from '@mui/icons-material/Apple';

export default function UpdatePublish(props) {
  const { appInfo, isAppBeingPublished } = useAppInfo();
  const { user } = useUser();

  const publishStatus = appInfo.iOSPublishStatus;
  const downloadUrl = appInfo.iOSDownloadUrl;

  function isMissingData() {
    return (
      _.isEmpty(user?.store?.title) ||
      _.isEmpty(user?.store?.shortDescription) ||
      _.isEmpty(user?.store?.description) ||
      _.isEmpty(user?.store?.privacyPolicyUrl) ||
      _.isEmpty(user?.store?.keywords) ||
      _.isEmpty(user?.store?.launchScreenUrl) ||
      _.isEmpty(user?.store?.iconUrl) ||
      _.isEmpty(user?.store?.featureGraphicUrl)
    )
  }

  return (
    <Box sx={{ paddingX: 2, paddingY: 4 }}>
      <Box display="flex" flexWrap="wrap" marginTop={2} sx={{ justifyContent: { sm: 'start', xs: 'center' } }}>
          <AppleIcon sx={{ color: "#2cc69d", marginRight: 1 }} />
          <Typography align="left" variant="subtitle1">
              Status do aplicativo iOS
          </Typography>
      </Box>

      <AppStatus
          downloadUrl={appInfo.iOSDownloadUrl}
          isAppBeingPublished={isAppBeingPublished('ios')}
          platformName="iOS"
          publishStatus={appInfo.iOSPublishStatus}
          storeName="App Store"
          lastPublishRequestedAt={appInfo.iOSLastPublishRequestedAt}
          deadlineInDays={20}
      />
      
      <Box mt={8}>
        {!isAppBeingPublished('ios') && isMissingData() &&
          <MissingDataCard />
        }

        {(publishStatus == 'first_publish_pending' || publishStatus == 'pending_update') && !isMissingData() &&
          <>
            <Warnings deadlineInDays={20} downloadUrl={downloadUrl} platformName="iOS" publishStatus={publishStatus} />
            <PublishButton platform="ios" />
          </>
        }

        {publishStatus == 'published' && !isMissingData() &&
          <PublishedCard platform="iOS" />
        }
      </Box>
    </Box>
  )
}